/**
 * Table component overrides.
 * Modern data grid with sticky blur headers and subtle hover.
 */

import type { Theme } from '@mui/material/styles';

const table: Theme['components'] = {
  MuiTable: {
    styleOverrides: {
      root: {
        borderCollapse: 'separate',
        borderSpacing: 0,
      },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        '& .MuiTableCell-head': {
          fontWeight: 600,
          fontSize: '0.6875rem',
          textTransform: 'uppercase' as const,
          letterSpacing: '0.08em',
          color: 'var(--mui-palette-text-secondary)',
          backgroundColor: 'var(--mui-palette-customColors-tableHeaderBg)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          position: 'sticky' as const,
          top: 0,
          zIndex: 2,
        },
      },
    },
  },
  MuiTableBody: {
    styleOverrides: {
      root: {
        '& .MuiTableRow-root': {
          transition: 'background-color 150ms ease',
          '&:hover': {
            backgroundColor: 'var(--mui-palette-action-hover)',
          },
        },
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        borderBottom: '1px solid var(--mui-palette-divider)',
        padding: '14px 16px',
      },
      head: {
        fontWeight: 600,
        fontSize: '0.6875rem',
        borderBottom: '1px solid var(--mui-palette-divider)',
      },
    },
  },
};

export default table;
